<template>
  <div class="slider">
    <div class="slider__body">
      <div
        class="slider__arrow slider__arrow--prev"
        :class="{ 'is-hidden' : currPage == 1 }"
        @click="currPage--"></div>
      <div class="slider__track">
        <div
          class="slider__mat"
          :style="{transform: 'translateX('+trackPos+')', justifyContent: numPages==1 ? 'center' : ''}"
        >
          <slot></slot>
        </div>
      </div>
      <div
        class="slider__arrow slider__arrow--next"
        :class="{ 'is-hidden' : currPage == numPages }"
        @click="currPage++" ></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign, prefer-template */
import {
  computed, defineComponent, getCurrentInstance, onMounted, ref,
} from '@vue/composition-api'

export default defineComponent({
  name: 'NavSlider',
  setup() {
    const vm = getCurrentInstance().proxy
    const perPage = ref(4)
    const numPages = ref(0)
    const currPage = ref(1)

    const trackPos = computed(() => '-' + ((currPage.value - 1) * 100) + '%')

    onMounted(() => {
      if (window.outerWidth <= 425) {
        perPage.value = 1
      } else if (window.outerWidth <= 768) {
        perPage.value = 2
      }

      let item = 1
      const items = vm.$slots.default.filter(_item => _item.tag)
      const size = 100 / perPage.value || 100

      // Add Size to Items and active class
      items.forEach((slot, index) => {
        slot.elm.style.width = size + '%'

        const url = new RegExp('^' + slot.elm.dataset.url, 'g')

        if (url.test(window.location.href)) {
          slot.elm.classList.add('is-active')
          item = index + 1
        }
      })

      // Get total number of pages
      numPages.value = Math.ceil(items.length / perPage.value)

      // Move page to highlighted item
      currPage.value = Math.ceil(item / perPage.value)
    })

    return {
      numPages,
      currPage,
      trackPos,
    }
  },
})
</script>
